export default __webpack_public_path__ + "5ed3d3982d44f3890e9e52e102fc137f.svg";